<template>
  <div class="tz-toc-list">
    <div
      class="tz-toc-list__selector"
      :class="{ 'tz-toc-list__selector--open': isOpen }"
      @click="toggleList"
      v-text="selectorText"
    />
    <ul
      class="tz-toc-list__list"
      :class="{ 'tz-toc-list__list--open': isOpen }"
    >
      <li
        class="tz-toc-list__item"
        :class="item.classname"
        :key="'tz-toc-list__item' + index + item"
        v-for="(item, index) in itemList"
      >
        <a
          class="tz-toc-list__link"
          :href="`#${item.anchor}`"
          @click="navigateToAnchor(item)"
        >
          <span class="tz-toc-list__label">{{ item.label }}</span>
          <span
            v-for="count in renderIf(item.count)"
            :key="'tz-toc-list__data--count' + index + count"
            class="tz-toc-list__data tz-toc-list__data--count"
            v-text="count"
          />
          <img
            v-for="image in renderIf(item.image)"
            :key="'tz-toc-list__data--image' + index + image"
            class="tz-toc-list__data tz-toc-list__data--image"
            :src="image"
            :alt="`Goto ${item.anchor}`"
          />
        </a>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'TzTocList',
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    // Array of objects to display.
    itemList: {
      type: Array,
      default: null // Expects `[{anchor: string, count: number|null, image: string|null, label: string}]`
    },
    // Text to display in selector
    selectorText: {
      type: String,
      default: 'Available Records'
    }
  },
  methods: {
    /**
     * If statement vue hack to prevent <!-- --> comment
     * @param condition
     * @returns {[]}
     */
    renderIf(condition) {
      return condition ? [condition] : [];
    },
    navigateToAnchor(item) {
      // Emit event with anchor link text when toc item is clicked on
      this.$emit('tz-toc-list-click', item.anchor);
    },
    toggleList() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
